@if ( !is_LinkedFileLoading && linkedTemplate.length == 0) {
<div
  (click)="!isRemoveEditSaveSharing && openManageTemplate()"
  [style.margin]="setZeroMargin ? '0px' : '0 -24px'"
  [ngClass]="show_left ? 'bg-white' : 'bg-transparent'"
  [ngStyle]="{ cursor: !hideManageButton && !isRemoveEditSaveSharing ? 'pointer' : 'default' }"
>
  <div class="app__centered-item flex-row text-center h-16 border rounded-lg border-[#d3dce8] border-solid">
    @if(isCapitalCommitment){
    <span class="app__form--attribute--title font-semibold text-[12px] ml-2">
      No <span class="font-bold text-[#25508E]"> Capital Commitment</span> to show
    </span>
    }@else{
    <img [src]="linked_record.icon_path" />
    <span class="app__form--attribute--title font-semibold text-[12px] ml-2">
      No <span class="font-bold text-[#25508E]"> {{ linked_record.label }}</span> to show
    </span>
    }
  </div>
</div>
} @if (!is_LinkedFileLoading && linkedTemplate.length) {
<div
  class="flex flex-col overflow-auto"
  [style.margin]="setZeroMargin ? '0px' : '0 -24px'"
  [ngClass]="{
    'max-h-[327px]': isCapitalCommitment,
    'max-h-[286px]': !isCapitalCommitment,
    'hover:cursor-pointer': !isRemoveEditSaveSharing
  }"
>
  @for (template of linkedTemplate; track template; let i = $index) {
  <div
    [matTooltip]="template?.writeAccess ? '' : 'You don’t have access to ' + template.form_name"
    class="group mb-1.5 p-3 border-[#d3dce8] border-solid border rounded-lg flex justify-between"
    [ngClass]="{
      'bg-white': show_left,
      'bg-transparent': !show_left,
      'hover:bg-[#EBF0FA] focus:bg-[#EBF0FA] focus:border-[#25508E] hover:cursor-pointer': !isRemoveEditSaveSharing,
      'pl-2': !hideCheckbox
    }"
    (click)="template?.writeAccess && openTemplate(template, i, template.display_file_name)"
  >
    <div class="flex w-full items-center gap-2">
      <mat-checkbox
        *ngIf="!hideCheckbox"
        class="app__common--multiple--selection--checkbox"
        [(ngModel)]="selectionState['linked_template_' + i]"
        (change)="onLocationLinkedTemplateSelectionChange(template, i, $event.checked)"
        (click)="$event.stopPropagation()"
      ></mat-checkbox>
      @if(template?.origin == "vault" || template?.origin == "contact" || template?.origin == "location" || template?.origin == "password" ){
      <img class="bg-[#f4f4f4] rounded p-1.5 h-10 mr-1.5 group-hover:bg-[#FFF] group-focus:bg-[#FFF]" [src]="template?.profile_image_url" />
      }@else{
      <div class="bg-[#F4F3F4] rounded p-1.5 h-10 mr-1.5">
        <file-extension [IconName]="template?.file_name | getFileExtension" [isActive]="true"> </file-extension>
      </div>
      }
      <div class="w-full">
        <div class="flex justify-between w-full">
          <div class="flex flex-col" [ngClass]="isCapitalCommitment ? 'gap-2' : ''">
            <p class="app__form--attribute--title text-sm leading-[20px] m-0">
              {{
                template?.origin == 'vault' || template?.origin == 'contact' || template?.origin == 'location' || template?.origin == 'password'
                  ? template.form_name
                  : (template.display_file_name | fileNameWithoutExtension)
              }}
            </p>
            @if(template?.origin == "vault" || template?.origin == "contact" || template?.origin == "location" || template?.origin == "password"){
            <p class="app__form--attribute--title m-0 text-xs text-[#707070] font-normal">{{ template?.vault_form_type }}</p>
            }@else{
            <p style="text-transform: capitalize" class="app__form--attribute--title m-0 text-xs text-[#707070] font-normal">
              {{ template?.file_name | getFileExtension }}
            </p>
            }
          </div>
          @if(isCapitalCommitment){
          <div class="flex flex-col gap-2 min-w-fit items-end">
            <p class="text-[12px] m-0 font-semibold">
              Total Commitment Balance:
              {{ template.totalCommitment | currency : 'USD' : 'symbol' : '1.2-2' }}
            </p>

            <div class="relative w-[200px] h-5 rounded border border-[#5475C0] overflow-hidden bg-white">
              <div class="bg-[#5475C0] h-full absolute top-0 left-0 z-0" [style.width.%]="getProgressPercentage(template)"></div>
              <div
                class="absolute top-0 left-0 w-full h-full flex items-center justify-center whitespace-nowrap text-xs text-white z-[2] text-ellipsis text-truncate font-semibold"
                style="z-index: 2"
              >
                Remaining:{{ template.remainingBalance | currency : 'USD' : 'symbol' : '1.2-2' }}
              </div>
              <div
                class="absolute top-0 left-0 w-full h-full flex items-center justify-center whitespace-nowrap text-xs text-[#5475C0] z-[3] text-ellipsis text-truncate font-semibold"
                [ngStyle]="{ 'clip-path': 'inset(0 0 0 ' + getProgressPercentage(template) + '%)' }"
                style="z-index: 3"
              >
                Remaining: {{ template.remainingBalance | currency : 'USD' : 'symbol' : '1.2-2' }}
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    @if (linked_record.label == 'Holdings') {
    <div>
      <p class="text-lg text-[#18191C] font-semibold m-0 relative top-1">
        {{ template.holdings_value ? '$' + (template.holdings_value | roundAmountTwoDecimal) : '-' }}
      </p>
    </div>
    }
  </div>
  }
</div>
} @if((!linkedTemplate.length || linkedTemplate.length == 0) && isCapitalCommitment || !isCapitalCommitment){ @if (!linkedLocation &&
!is_LinkedFileLoading&& !hideSuggestion && linked_record.template_list.length && !hideManageButton) {
<div
  (click)="!isRemoveEditSaveSharing && openManageTemplate()"
  [ngStyle]="{ cursor: !hideManageButton && !isRemoveEditSaveSharing ? 'pointer' : 'default' }"
  class="app__centered-item flex-row text-center h-[38px] bg-[#ebf0fa] rounded mt-2"
  [ngClass]="setZeroMargin ? 'mx-[0px]' : 'mx-[-20px]'"
>
  <img [src]="linked_record.suggestion_icon_pth" width="18px" height="18px" />
  <span class="app__form--attribute--title font-semibold text-[#18191C] text-[12px] ml-2">
    View Suggestions <span class="font-bold text-[#25508E]">({{ linked_record.template_list.length }})</span>
  </span>
</div>
} } @if (is_LinkedFileLoading) {
<div class="ph-item width-100per loader-body-item" [style.margin]="setZeroMargin ? '0px' : '0 -24px'" style="padding: 0px; border: 0px">
  <div class="ph-col-12" style="padding: 0px !important">
    <div class="ph-row" style="margin: 12px">
      <div class="ph-col-4"></div>
      <div class="ph-col-6 empty"></div>
      <div class="ph-col-2"></div>
    </div>
  </div>
</div>
}
